import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from '@emotion/styled';

const CovidBanner = () => {
    const [covidData, setCovidData] = useState();

    useEffect(() => {
        axios.get(`https://corona.lmao.ninja/v2/countries/Jamaica?yesterday&strict&query%20`)
            .then(res => {
                setCovidData(res.data);
            })
    }, []);

    return (
        <BannerWrapper>
            <BannerContainer>
                <HeaderText> COVID Tracker Jamaica </HeaderText>
                <div className="case-data">
                    <CaseInfo>
                        <h4 className="case-category"> Total Cases </h4>
                        <h3 className="case-numbers"> {covidData?.cases}</h3>
                    </CaseInfo>

                    <CaseInfo>
                        <h4 className="case-category"> Active Cases </h4>
                        <h3 className="case-numbers"> {covidData?.active} </h3>
                    </CaseInfo>

                    <CaseInfo>
                        <h4 className="case-category"> Deaths </h4>
                        <h3 className="case-numbers"> {covidData?.deaths}</h3>
                    </CaseInfo>

                    <CaseInfo>
                        <h4 className="case-category"> Recovered </h4>
                        <h3 className="case-numbers"> {covidData?.recovered}</h3>
                    </CaseInfo>
                </div>
            </BannerContainer>
        </BannerWrapper>
    );
}
export default CovidBanner;

const BannerWrapper = styled.div`
    height: var(--header-height);
    width: 100%;
    background-color: #fff;
    border-bottom: 2px solid #D3D9DE;

    z-index: 20;

    @media only screen and (max-width: 768px) {
		display: none;
	}
`;

const BannerContainer = styled.div`
    height: 100%;
    width: 100%;
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding: 1rem 6rem 1rem 3rem;

    .case-data{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .case-category{
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        white-space: nowrap;
        color: #8D9AA5;
    }

    .case-numbers{
        font-weight: 500;
        font-size: 24px;
        line-height: 24px;

        color: #327D8F;
    }
`;

const CaseInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 6rem;
`;

const HeaderText = styled.h3`
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;

    color: #327D8F;
`